// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zGgvX","toggle":"styles_toggle__3Dn7u","preview":"styles_preview__22boc"};